import { IPayment } from "@/apps/merchant3/models/IPayment";

const mutations = {
  SET_PAYMENT_INFO: (state: IPayment, payload: IPayment): void => {
    Object.keys(payload).forEach((key) => (state[key] = payload[key]));
  },
  REMOVE_PAYMENT_INFO: (state: IPayment): void => {
    Object.keys(state).forEach((key) => (state[key] = null));
  },
  SET_PAYMENT_ID: (
    state: IPayment,
    payload: IPayment["paymentPayload"]
  ): void => {
    state.paymentPayload = payload;
  },
};
export default mutations;
